import React from "react";
import styled from "styled-components";

export default function BlogBox({ tag, title, text, action, author }) {
  return (
    <WrapperBtn
      className="animate pointer"
      onClick={action ? () => action() : null}
    >
      <Wrapper className="whiteBg radius8 shadow">
        <h3
          style={{ fontFamily: "Josefin Sans, sans-serif" }}
          className="font20 extraBold text-center"
        >
          {title}
        </h3>
        <p className="font13" style={{ padding: "30px 0" }}>
          {text}
        </p>
        <p className="font13 extraBold">{author}</p>
        <div className="flex">
          {/* <p className="tag coralBg radius6 font13 extraBold">{tag}</p> */}
        </div>
      </Wrapper>
    </WrapperBtn>
  );
}

const Wrapper = styled.div`
  width: 100%;
  text-align: left;
  background: aliceblue ;
  padding: 20px 30px;
  margin-top: 20px;
  
`;
const WrapperBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  :hover {
    opacity: 0.5;
  }
`;
